import { FaBookOpen, FaBrain, FaDollarSign } from "react-icons/fa";
import { FiZap } from "react-icons/fi";
import Button from "../../components/EmptyButton";
import { useHistory } from "react-router-dom";

export default function Credits() {
  const navigate = useHistory();
  const credits = 0;

  const features = [
    {
      icon: FaBrain,
      title: "Personalized Learning",
      description:
        "AI is trained with high quality academic resources to give accurate responses and adapts to your learning style, pace, and course materials for maximum effectiveness.",
    },
    {
      icon: FiZap,
      title: "Instant Feedback",
      description:
        "Get immediate explanations in simple words and corrections based on your uploaded course content.",
    },
    {
      icon: FaBookOpen,
      title: "Course-Specific Content",
      description:
        "Upload your course materials and lecture notes for tutoring tailored to your specific curriculum.",
    },
    {
      icon: FaDollarSign,
      title: "Simple Pricing",
      description:
        "Subscriptions are flexible. It can be upgraded or canceled anytime.",
    },
  ];

  const handleBuyCredits = () => {
    navigate.push("/tutor-subscription");
  };

  const handleStartLearning = () => {
    navigate.push("/aitutor");
  };

  return (
    <div className="min-h-screen bg-warm-bg font-inter">
      {/* Header Badge */}
      <div className="flex justify-center pt-12">
        <div className="bg-primary/10 text-primary border border-primary/20 px-6 py-2 rounded-full text-sm font-semibold">
          🧠 AI-Powered Learning
        </div>
      </div>

      {/* Hero Section */}
      <div className="text-center py-20 px-6">
        <h1 className="text-4xl lg:text-6xl font-bold text-foreground leading-tight text-center">
          <span
            className="text-primary"
            style={{ fontSize: "3.75rem", fontWeight: "700" }}
          >
            Your Personal
          </span>
          <span
            className="text-foreground ml-2"
            style={{ fontSize: "3.75rem", fontWeight: "700" }}
          >
            AI Tutor
          </span>
        </h1>

        <p
          style={{ color: "#78726d" }}
          className="text-xl text-muted-foreground leading-relaxed"
        >
          Get personalized tutoring, instant feedback, and adaptive learning
          experiences. Upload your course materials and purchase credits to
          unlock unlimited learning potential.
        </p>

        {/* Credits Display */}
        <div className="mb-12 mt-24">
          <p style={{fontSize: '20px', color: '#78726d'}} className=" text-gray-600 mb-2 font-bold">
            Your Credits:
          </p>
          <div className="font-bold text-primary mb-8" style={{ fontSize: "3.75rem", fontWeight: "700" }}>{credits}</div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <div className="" style={{ width: "250px" }}>
                <Button onClick={handleBuyCredits} filled={true} className="text-lg px-4 w-24">
                  Get Credits
                </Button>
              </div>
              <div className="" style={{ width: "250px" }}>
                <Button
                  onClick={handleStartLearning}
                  className="text-lg px-8"
                  
                >
                  Start Learning
                </Button>
              </div>
            </div>
        </div>
      </div>

      {/* Features Grid */}
      <div className="max-w-7xl mx-auto px-6 pb-20">
        <div className="grid md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-10 bg-white border-0 shadow-lg rounded-2xl hover:shadow-xl transition-all duration-200"
            >
              <div className="flex items-start gap-0">
              <div className="w-48 h-48 bg-gradient-hero rounded-lg flex justify-left group-hover:scale-110 transition-transform duration-300">
                  <feature.icon
                    className="text-primary-foreground text-primary"
                    style={{ fontSize: "3rem" }}
                  />
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-4 text-gray-800">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed whitespace-pre-line text-lg">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}